//#region src/date-picker/time-picker/utils/generate-placeholder-from-format.ts
var e = (e) => {
	let t = {
		a: "AM/PM",
		h: "-",
		hh: "--",
		H: "-",
		HH: "--",
		m: "-",
		mm: "--",
		s: "-",
		ss: "--"
	};
	return e.split(/([^\w])/g).map((e) => t[e] || e).join("");
};
//#endregion
export { e as generatePlaceholderFromFormat };
